import { render } from "./Size.vue?vue&type=template&id=a91fe6f2"
import script from "./Size.vue?vue&type=script&lang=js"
export * from "./Size.vue?vue&type=script&lang=js"

import exportComponent from "/Users/williamsandstrom/repos/web/ytopi/ytopi-configurator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__